
// CORE
import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';

// Data
import { useDispatch } from 'react-redux'
import { getSortedTransactionsForAccountIds } from 'data/transactionList/selectors';
import { removeDialog } from 'data/rootUi/actions';

// Custom
import useQData from 'components/QData/useQData';
import SelectTransactionDialog from 'components/Dialogs/SelectTransactionDialog';


const MatchTxnDialog = (props) => {

  const { txn } = props;
  const dispatch = useDispatch();

  const { qDataMatchTransactions } = useQData();

  function onClose() {
    dispatch(removeDialog());
  }

  // data stuff
  const matchOverdueTransaction = (targetTxn) => {
    qDataMatchTransactions([targetTxn, txn]);
    onClose();
  };

  return (
    <SelectTransactionDialog
      open
      title="Find Transaction to Match"
      headline="Link Transaction"
      subtitle={`for '${txn.payee}'`}
      buttonText="Link"
      disableAdd
      onClose={onClose}
      onTransactionSelected={matchOverdueTransaction}
      transactionListSelector={getSortedTransactionsForAccountIds}
      selectorProps={{ matchTxn: txn, accountIds: List([txn.accountId]) }}
    />
  );
};

MatchTxnDialog.defaultProps = {
  txn: {},
};

MatchTxnDialog.propTypes = {
  txn: PropTypes.object,
};

export default MatchTxnDialog;
